export default "__VITE_PUBLIC_ASSET__16cb478b__"